import { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { 
  Mail, Linkedin, GraduationCap, Award,
  ArrowLeft, Users
} from "lucide-react";
import { Button } from "@/components/ui/button";

// Team Data
const partners = [
  {
    name: "CA. Rajendra Kumar P",
    designation: "Partner",
    image: "/rajendra.JPG",
    qualifications: "FCA, LLB",
    experience: "25+ Years",
    expertise: ["GST & Indirect Taxation", "Corporate Law", "Litigation"],
    email: "rk@ssaca.in",
    linkedin: "https://www.linkedin.com/in/ca-rajendra-kumar-p-4099925"
   },
   {
     name: "CA. Ramakrishnan G",
    designation: "Partner",
    image: "/ramakrishnan.png",
    qualifications: "FCA, CPA",
    experience: "20+ Years",
    expertise: ["Internal Audit", "Risk Advisory", "Forensic Audit"],
     email: "ram@ssaca.in",
     linkedin: "https://www.linkedin.com/in/gurumurthi-ramakrishnan-4b3ba770"
   },
   {
     name: "CA. Ashok J Deora",
    designation: "Partner",
    image: "/Ashok.png",
    qualifications: "FCA, CISA",
    experience: "18+ Years",
    expertise: ["IT Audit", "System Implementation", "Process Consulting"],
    email: "ashok@ssaca.in",
    linkedin: "https://www.linkedin.com/in/ashok-deora-190a7b"
  },
  {
    name: "CA. Bharath Kumar N K",
    designation: "Partner",
    image: "/bharath.png",
    qualifications: "FCA, CISA",
    experience: "18+ Years",
    expertise: ["IT Audit", "System Implementation", "Process Consulting"],
    email: "bharat@ssaca.in",
    linkedin: "https://www.linkedin.com/in/bharath-kumar-44135517"
  },
  {
    name: "CA. Shaikh Abdul Samad A",
    designation: "Partner",
    image: "/samad.png",
    qualifications: "FCA, CISA",
    experience: "18+ Years",
    expertise: ["IT Audit", "System Implementation", "Process Consulting"],
    email: "samad@ssaca.in",
    linkedin: "https://www.linkedin.com/in/shaikh-abdul-samad-ahmad-1b559365"
  },
  {
    name: "CA. Hitesh Jain",
    designation: "Partner",
    image: "/hitesh.png",
    qualifications: "FCA, CISA",
    experience: "18+ Years",
    expertise: ["IT Audit", "System Implementation", "Process Consulting"],
    email: "hitesh@ssaca.in",
     linkedin: "https://www.linkedin.com/in/hituca"
   },
     {
     name: "CA. K. Rajesh Jain",
    designation: "Partner",
    image: "/rajesh.png",
    qualifications: "FCA, CISA",
    experience: "18+ Years",
    expertise: ["IT Audit", "System Implementation", "Process Consulting"],
    email: "rajesh@ssaca.in",
     linkedin: "https://www.linkedin.com/in/rajesh-jain-b1b996237"
   },
     {
     name: "CA. Viral M Khandhar",
    designation: "Partner",
    image: "/viral.png",
    qualifications: "FCA, CISA",
    experience: "18+ Years",
    expertise: ["IT Audit", "System Implementation", "Process Consulting"],
    email: "viral@ssaca.in",
    linkedin: "https://www.linkedin.com/in/viralmkhandhar"
  },
  {
    name: "CA. Jainendar P",
    designation: "Partner",
    image: "/jainendra.png",
    qualifications: "FCA, CISA",
    experience: "18+ Years",
    expertise: ["IT Audit", "System Implementation", "Process Consulting"],
    email: "Jainendar@ssaca.in",
    linkedin: "https://www.linkedin.com/in/jainendar-p-399b0348"
  },
   {
    name: "CA. Anand Marlecha",
    designation: "Partner",
    image: "/Anand.png",
    qualifications: "FCA, CISA",
    experience: "18+ Years",
    expertise: ["IT Audit", "System Implementation", "Process Consulting"],
     email: "anand@ssaca.in",
     linkedin: "https://www.linkedin.com/in/anand-marlecha-6aa163110"
   },
     {
      name: "CA. Gagan R",
     designation: "Partner",
     image: "/gagag-.png",
     qualifications: "FCA, CISA",
     experience: "18+ Years",
     expertise: ["IT Audit", "System Implementation", "Process Consulting"],
      email: "gagan@ssaca.in",
      linkedin: "https://www.linkedin.com/in/gagan-gelada"
    },
    {
     name: "CA. Darshit Kothari S",
     designation: "Partner",
     image: "/darshit.png",
     qualifications: "FCA, CISA",
     experience: "18+ Years",
     expertise: ["IT Audit", "System Implementation", "Process Consulting"],
      email: "darshit@ssaca.in",
      linkedin: "https://www.linkedin.com/in/darshit-kothari"
    },
  ];

const alumni = [];

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
};

const OurPeoplePage = () => {
  const [activeTab, setActiveTab] = useState("team");

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-[#0B1120] pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Link 
            to="/" 
            className="inline-flex items-center text-white/70 hover:text-[#C5A059] mb-8 transition-colors"
          >
            <ArrowLeft size={18} className="mr-2" />
            Back to Home
          </Link>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-16 h-1 bg-[#C5A059]" />
              <span className="text-[#C5A059] font-medium text-sm uppercase tracking-widest">
                Our People
              </span>
            </div>
            
            <h1 className="logo-font text-4xl sm:text-5xl lg:text-6xl text-white font-bold mb-6">
              The <span className="text-[#C5A059]">SSA</span> Team
            </h1>
            
            <p className="text-white/70 text-lg max-w-2xl">
              A blend of seasoned partners along with a fervent workforce of dynamic professionals, 
              committed to excellence and client success.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Tab Navigation */}
      <section className="sticky top-20 z-40 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex gap-8">
            <button
              onClick={() => setActiveTab("team")}
              className={`py-4 text-sm font-semibold uppercase tracking-widest border-b-2 transition-colors ${
                activeTab === "team" 
                  ? "border-[#C5A059] text-[#0B1120]" 
                  : "border-transparent text-slate-500 hover:text-[#0B1120]"
              }`}
            >
              <Users size={16} className="inline mr-2" />
              Team
            </button>
            <button
              onClick={() => setActiveTab("alumni")}
              className={`py-4 text-sm font-semibold uppercase tracking-widest border-b-2 transition-colors ${
                activeTab === "alumni" 
                  ? "border-[#C5A059] text-[#0B1120]" 
                  : "border-transparent text-slate-500 hover:text-[#0B1120]"
              }`}
            >
              <GraduationCap size={16} className="inline mr-2" />
              Alumni
            </button>
          </div>
        </div>
      </section>

      {/* Team Content */}
      {activeTab === "team" && (
        <>
          {/* Partners Section */}
          <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="mb-12"
              >
                <h2 className="font-serif text-3xl font-bold text-[#0B1120] mb-4">
                  Partners
                </h2>
                <p className="text-slate-600 max-w-2xl">
                  Our partners bring decades of combined experience across diverse sectors, 
                  leading client engagements with expertise and dedication.
                </p>
              </motion.div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={staggerContainer}
                className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
              >
                {partners.map((partner) => (
                  <motion.div
                    key={partner.name}
                    variants={fadeInUp}
                    className="group"
                  >
                    <div className="relative overflow-hidden rounded-xl mb-4">
                      <img
                        src={partner.image}
                        alt={partner.name}
                        className="w-full h-72 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                         <div className="absolute bottom-4 right-4 flex gap-2">
                           <a 
                             href={partner.linkedin}
                             target="_blank"
                             rel="noopener noreferrer"
                             className="w-10 h-10 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white hover:bg-[#C5A059] transition-colors"
                           >
                             <Linkedin size={16} />
                           </a>
                         </div>
                      </div>
                    </div>
                    <h3 className="font-serif text-xl font-semibold text-[#0B1120] mb-1">
                      {partner.name}
                    </h3>
                    <p className="text-[#C5A059] text-sm font-medium mb-2">
                      {partner.designation}
                    </p>
                  </motion.div>
                ))}
              </motion.div>
            </div>
          </section>

          {/* Stats */}
          <section className="py-16 bg-[#0B1120]">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                <div>
                  <div className="text-4xl font-serif font-bold text-[#C5A059] mb-2">12</div>
                  <div className="text-white/70 text-sm">Partners</div>
                </div>
                <div>
                  <div className="text-4xl font-serif font-bold text-[#C5A059] mb-2">100+</div>
                  <div className="text-white/70 text-sm">Work force</div>
                </div>
                <div>
                  <div className="text-4xl font-serif font-bold text-[#C5A059] mb-2">15+</div>
                  <div className="text-white/70 text-sm">Professionals</div>
                </div>
                <div>
                  <div className="text-4xl font-serif font-bold text-[#C5A059] mb-2">3</div>
                  <div className="text-white/70 text-sm">Office Locations</div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}

      {/* Alumni Content */}
      {activeTab === "alumni" && (
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="mb-12"
            >
              <h2 className="font-serif text-3xl font-bold text-[#0B1120] mb-4">
                SSA Alumni Network
              </h2>
              <p className="text-slate-600 max-w-2xl">
                Our alumni have gone on to achieve remarkable success in their careers. 
                We take pride in being a launchpad for future industry leaders.
              </p>
            </motion.div>

            <motion.div
              initial="hidden"
              animate="visible"
              variants={staggerContainer}
              className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
            >
              {alumni.map((person) => (
                <motion.div
                  key={person.name}
                  variants={fadeInUp}
                  className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-[#C5A059]/30 hover:shadow-lg transition-all"
                >
                  <img
                    src={person.image}
                    alt={person.name}
                    className="w-20 h-20 rounded-full object-cover mb-4"
                  />
                  <h3 className="font-serif text-lg font-semibold text-[#0B1120] mb-1">
                    {person.name}
                  </h3>
                  <p className="text-[#C5A059] text-sm font-medium mb-2">
                    {person.currentRole}
                  </p>
                  <p className="text-slate-500 text-sm">
                    <Award size={14} className="inline mr-1" />
                    SSA Tenure: {person.tenure}
                  </p>
                </motion.div>
              ))}
            </motion.div>

            {/* Alumni CTA */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mt-16 bg-slate-100 rounded-2xl p-8 md:p-12 text-center"
            >
              <GraduationCap size={48} className="mx-auto text-[#C5A059] mb-4" />
              <h3 className="font-serif text-2xl font-bold text-[#0B1120] mb-4">
                Are You an SSA Alumnus?
              </h3>
              <p className="text-slate-600 mb-6 max-w-xl mx-auto">
                Stay connected with your SSA family. Join our alumni network to receive updates, 
                invitations to events, and opportunities to mentor the next generation.
              </p>
              <Button className="bg-[#0B1120] hover:bg-[#C5A059] text-white px-8 py-6">
                Join Alumni Network
              </Button>
            </motion.div>
          </div>
        </section>
      )}

      {/* CTA Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-serif text-3xl font-bold text-[#0B1120] mb-4">
            Want to Join Our Team?
          </h2>
          <p className="text-slate-600 mb-8 max-w-xl mx-auto">
            We're always looking for talented professionals who share our passion for excellence.
          </p>
          <Link to="/careers">
            <Button className="bg-[#C5A059] hover:bg-[#0B1120] text-white px-8 py-6">
              View Open Positions
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default OurPeoplePage;